module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Application Decision"},"fr":{"title":"Décision de l\u0027application"}}')
  delete Component.options._Ctor
}
